import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Enso } from "./SacredGeometry";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-sanctuary-deep">
        <Enso className="w-16 h-16 text-gold spin-slow" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};
